import { useState } from "react";
import { validateTimes } from "../../api/times";
import { sendEmailHolidays, validateNotSendHolidays } from "../../api/events";
import { showToastError, showToastSuccess } from "../../services/toast";
import { useTimeStore } from "../../stores/time";
import { useUserContext } from "../../contexts/userContext";

const ValidateTime = () => {
  const { idTimesSelected, update, setUpdate, setTimesToValidate, tab, setRequestsHolidays, setIdTimesSelected} =
    useTimeStore();
  const { rights } = useUserContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleValidate = () => {
    if (idTimesSelected.length === 0) {
      showToastError("Veuillez sélectionner au moins un temps");
      return;
    } else {
      setIsLoading(true);
      // Validation des temps
      if(tab === "TimeToValidate") {
        validateTimes(idTimesSelected)
          .then(() => {
            setUpdate(!update);
            showToastSuccess("Temps validé");
            setTimesToValidate([]);
          })
          .catch(() => {
            showToastError("Une erreur est survenue");
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else if(tab === "HolidaysToValidate" && !rights.includes(1004) /*Si ce n'est pas Ute*/) {
        // Validation des demandes de congés / abscences
        validateNotSendHolidays(idTimesSelected)
        .then(() => {
          setUpdate(!update);
          showToastSuccess("Demandes de congés / abscences validées");
          setRequestsHolidays([]);
          setIdTimesSelected([]);
        })
        .catch(() => {
          showToastError("Une erreur est survenue");
        })
        .finally(() => {
          setIsLoading(false);
        });
      } else if(tab === "HolidaysToValidate" && rights.includes(1004) /*Si cest Ute*/) {
        // Envoi des emails de validation des demandes de congés / abscences
        sendEmailHolidays(idTimesSelected)
          .then(() => {
            setUpdate(!update);
            showToastSuccess("Emails de validation des demandes de congés / abscences envoyés");
            setRequestsHolidays([]);
            setIdTimesSelected([]);
          })
          .catch(() => {
            showToastError("Une erreur est survenue");
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  };

  return (
    <button
      onClick={handleValidate}
      disabled={isLoading}
      className="px-4 py-2 mr-2 bg-blue-500 text-white rounded hover:bg-blue-600 cursor-pointer my-2 transition-all duration-300 font-Nunito disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
    >
      {isLoading && (
        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      )}
      {isLoading ? "Validation..." : "Valider"}
    </button>
  );
};

export default ValidateTime;
